import type { SupportedTimeZone } from '@/constants/date';
import { formatDate } from '@/utils/date';

export const formatNoteDate = (
  dateString: string | undefined,
  timeZone: SupportedTimeZone = 'ET',
): string => {
  if (!dateString) return '';
  return formatDate(dateString, timeZone);
};
